import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { viewPrePopulateForm } = formModuleLenses

export default (state, { moduleId }) => {
	const prePopulateForm = viewPrePopulateForm(moduleId, moduleDescriptions)
	if (prePopulateForm) {
		return prePopulateForm(state)
	}
	return null
}
